import React from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer/dist/react-pdf.es';
import moment from "moment";
import i18n from "../../../../i18n";


const styles = StyleSheet.create({
    container:{
        flexDirection: 'row',
        textAlign: 'justify',
        fontFamily: 'Crimson',
        marginRight:'10mm',
    },
    columnLeft:{
        flexDirection: 'column',
        flexGrow: 2,
    },
    columnCenter:{
        flexDirection: 'column',
        flexGrow: 3,
    },
    columnRight: {
        flexDirection: 'column',
        flexGrow: 2,
        alignItems: 'center',
    },
    label: {
        fontSize:8
    },
    text:{
        fontFamily: 'Lato',
        fontSize: 9,
    },
});

export default ({...props}) => {

    const {values} = props;

    return (
        <View style={styles.container}>
            <View style={styles.columnLeft}>
                <Text style={styles.label}>{i18n.get('deficiency.pdf.your_message_from')}</Text>
                <Text style={styles.text}>{''}</Text>
            </View>
            <View style={styles.columnCenter}>
                <Text style={styles.label}>{i18n.get('deficiency.pdf.your_sign')}</Text>
                <Text style={styles.text}>{''}</Text>
            </View>
            <View style={styles.columnCenter}>
                <Text style={styles.label}>{i18n.get('deficiency.pdf.our_sign')}</Text>
                <Text style={styles.text}>{values.owner && values.owner.name}</Text>
            </View>
            <View style={styles.columnRight}>
                <Text style={styles.label}>{i18n.get('deficiency.pdf.date')}</Text>
                <Text style={styles.text}>{moment().format('DD.MM.YYYY')}</Text>
            </View>
        </View>
    );

};
